import './styles.scss';

// eslint-disable-next-line
export default require(`./${process.env.BRAND_NAME}.scss`).default;



/** WEBPACK FOOTER **
 ** ./src/pages/ModelView/TrimSelector/styles.js
 **/